export default "__VITE_ASSET__rMgLvcg2__"